// extracted by mini-css-extract-plugin
module.exports = {"tnc_title":"_2zaf838","check_list":"_2QoP9w-","tnc_instruction":"_3GiywBZ"};